module.exports = __webpack_public_path__ + "static/media/navigate-right-orange.df2cf008.svg";